import { UserDetails } from '@coach-bot/data-access/shared/models';
import { captureSentryMessage, safeSentryCaptureException } from '@shared/sentry';
import { getLocalStorage } from './local-storage';

const USER_DETAILS_STORAGE_KEY = 'UserStore:UserDetails';

export async function getEmailFromUserDetails(): Promise<string | null> {
  try {
    const userDetailsString: string | undefined = await getLocalStorage(USER_DETAILS_STORAGE_KEY);
    captureSentryMessage(`User details from storage: ${userDetailsString}`);
    if (userDetailsString) {
      const storedUserDetails: UserDetails = JSON.parse(userDetailsString);
      if (storedUserDetails && storedUserDetails.email) {
        return storedUserDetails.email;
      }
    }
  } catch (ex: unknown) {
    const error = new Error(`Error getting email from user details: ${ex}`);
    console.error(error);
    safeSentryCaptureException(error);
  }
  return null;
}
